export default "__VITE_ASSET__7c0f61a4__"